// libs
import { Dispatch } from "react";

// defs
import { IAction } from "@defs/Action";
import { IAllocationType } from "@defs/Utilities";
import { IUserInfoState } from "@store/state/UserInfo";
import { UserSandboxAccess } from "@utils/appsync/schema/API";

// Action types for user-related state
export enum UserInfoActionType {
    SET_EMAIL = "SET_EMAIL",
    SET_USERNAME = "SET_USERNAME",
    SET_IS_USER_AUTHORIZED = "SET_IS_USER_AUTHORIZED",
    SET_SELECTED_SANDBOX = "SET_SELECTED_SANDBOX",
    SET_SANDBOXES = "SET_SANDBOXES",
    SET_SELECTED_ALLOCATION_TYPE = "SET_SELECTED_ALLOCATION_TYPE",
    SET_USER_INFO = "SET_USER_INFO",
    SET_FEATURE_FLAGS = "SET_FEATURE_FLAGS",
}

// Action to set user email
export const setEmail = (dispatch: Dispatch<IUserInfoAction>) => {
    return (email: string) => {
        dispatch({
            type: UserInfoActionType.SET_EMAIL,
            payload: { email },
        });
    };
};

// Action to set username
export const setUsername = (dispatch: Dispatch<IUserInfoAction>) => {
    return (username: string) => {
        dispatch({
            type: UserInfoActionType.SET_USERNAME,
            payload: { username },
        });
    };
};

// Action to set user authorization status
export const setIsUserAuthorized = (dispatch: Dispatch<IUserInfoAction>) => {
    return (isUserAuthorized: boolean) => {
        dispatch({
            type: UserInfoActionType.SET_IS_USER_AUTHORIZED,
            payload: { isUserAuthorized },
        });
    };
};

// Action to set selected sandbox
export const setSelectedSandbox = (dispatch: Dispatch<IUserInfoAction>) => {
    return (selectedSandbox: UserSandboxAccess) => {
        dispatch({
            type: UserInfoActionType.SET_SELECTED_SANDBOX,
            payload: { selectedSandbox },
        });
    };
};

// Action to set user sandboxes
export const setSandboxes = (dispatch: Dispatch<IUserInfoAction>) => {
    return (sandboxes: Array<UserSandboxAccess>) => {
        dispatch({
            type: UserInfoActionType.SET_SANDBOXES,
            payload: { sandboxes },
        });
    };
};

// Action to set selected allocation type
export const setSelectedAllocationType = (dispatch: Dispatch<IUserInfoAction>) => {
    return (selectedAllocationType: IAllocationType) => {
        dispatch({
            type: UserInfoActionType.SET_SELECTED_ALLOCATION_TYPE,
            payload: { selectedAllocationType },
        });
    };
};

// Action to set user info
export const setUserInfo = (dispatch: Dispatch<IUserInfoAction>) => {
    return (userInfo: Partial<IUserInfoState>) => {
        dispatch({
            type: UserInfoActionType.SET_USER_INFO,
            payload: { ...userInfo },
        });
    };
};

// Action to set feature flags
export const setFeatureFlags = (dispatch: Dispatch<IUserInfoAction>) => {
    return (featureFlags: object) => {
        dispatch({
            type: UserInfoActionType.SET_FEATURE_FLAGS,
            payload: { featureFlags },
        });
    };
};

// Action interfaces
export interface IUserInfoAction extends IAction<UserInfoActionType, IUserInfoState> {}
